import { createSelector } from 'reselect'
import getGroupPaymentLeadContributionAmount from './getGroupPaymentLeadContributionAmount'

// Lead contribution only — credit/gift are subtracted in getMerchantFeeAmount to avoid a circular import.
const getGroupPaymentMerchantFeeEligibleAmount = createSelector(
  getGroupPaymentLeadContributionAmount,
  (leadContributionAmount): number => leadContributionAmount,
)

export default getGroupPaymentMerchantFeeEligibleAmount
